/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { IconWrapper } from "../../customHooks/useIcon";
import { FaTimes } from "react-icons/fa";

interface SelectedDeviceTagsProps {
  selectedDevices: string[];
  onRemoveDevice: (device: string) => void;
  className?: string;
  maxVisible?: number;
}

const SelectedDeviceTags: React.FC<SelectedDeviceTagsProps> = ({
  selectedDevices,
  onRemoveDevice,
  className = "",
  maxVisible = 5,
}) => {
  if (selectedDevices.length === 0) {
    return null;
  }

  const visibleDevices = selectedDevices.slice(0, maxVisible);
  const remainingCount = selectedDevices.length - maxVisible;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {visibleDevices.map((device) => (
        <div
          key={device}
          className="inline-flex items-center bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full border border-blue-200"
        >
          <span className="mr-1 truncate max-w-[120px]" title={device}>
            {device}
          </span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveDevice(device);
            }}
            className="ml-1 hover:bg-blue-200 rounded-full p-0.5 transition-colors"
            aria-label={`Remove ${device}`}
          >
            <IconWrapper icon={FaTimes} className="h-2.5 w-2.5" />
          </button>
        </div>
      ))}

      {remainingCount > 0 && (
        <div className="inline-flex items-center bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full border border-gray-200">
          <span>+{remainingCount} more</span>
        </div>
      )}

      {selectedDevices.length > 0 && (
        <button
          type="button"
          onClick={() => {
            selectedDevices.forEach((device) => onRemoveDevice(device));
          }}
          className="text-xs text-red-500 hover:text-red-700 underline transition-colors"
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default SelectedDeviceTags;
